import { ToasterService } from '~commonInfra/services/ToasterService';
import { getVizPath } from '~commonInfra/url/UrlHelpers';
import { ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';

import { useEffectOnUrlChange } from './UseEffectOnUrlChange';

/**
 * Dismiss modal dialogs on location change e.g. if the user clicks the back button
 * Modals should only close when we're going to a different page.
 * TFS827926 - Lightbox (modal) closes when the InstanceId is changed after load.
 * AFAIK, the only place the query params in hash identifier are changed is in viewing a viz.
 */
export function useDismissModalsHandler() {
  useEffectOnUrlChange((newUrl, oldUrl) => {
    if (!isOnSameViewPath(newUrl, oldUrl) && !isOnSamePath(newUrl, oldUrl)) {
      ReactModalService.dismissAll('location change');
      ToasterService.instance.closeAllToastsNotMarkedAsKeep();
    }
  }, []);
}

/**
 * Used to make sure the path hasn't changed during a route re-render
 */
function isOnSamePath(newUrl: string, oldUrl: string): boolean {
  return newUrl === oldUrl;
}

/**
 * Checks whether the viz path is the same
 * Returns null if the path is not a viz.
 */
function isOnSameViewPath(newUrl: string, oldUrl: string): boolean {
  const newPath = getVizPath(newUrl);
  const oldPath = getVizPath(oldUrl);

  // We're not comparing a view or workbook path if these are null
  if (newPath === null || oldPath === null) {
    return false;
  }

  return newPath === oldPath;
}
